export default __webpack_public_path__ + "static/media/Ballroll_00328.e21de968.png";